import { css } from 'lit';

export const styles = css`
  .cbi-doc-info {
    width: 100%;
    width: 800px;
    margin: 16px auto;
    box-sizing: border-box;
    font-size: 12px;
  }
  .cbi-doc-info * {
    box-sizing: border-box;
  }
  .cbi-doc-info .hide-info {
    display: flex;
    gap: 4px;
    align-items: center;
    visibility: hidden;
    color: #6d6e6f;
    cursor: pointer;
  }

  .cbi-doc-info .info-btn {
    position: absolute;
    top: -2px;
    left: -34px;
    display: none;
    padding-right: 8px;
  }
  .cbi-doc-info .info-btn .btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 26px;
    height: 20px;
    padding: 0 4px;
    border-radius: 2px;
    border: 1px solid var(--30_Disabled, #eceae9);
    cursor: pointer;
  }
  .cbi-doc-info .infos {
    position: relative;
    display: flex;
    align-items: center;
    gap: 16px;
  }
  .cbi-doc-info .infos:hover .info-btn {
    display: flex;
  }
  .cbi-doc-info .info {
    display: flex;
    gap: 8px;
  }
  .cbi-doc-info .info-title {
    color: #afabac;
    font-weight: 600;
  }
  .cbi-doc-info .divider {
    width: 1px;
    height: 12px;
    background: #eceae9;
  }
  .cbi-doc-info .info-value.user {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .cbi-doc-info .info-value.user .avatar {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    font-size: 10px;
  }
  .cbi-doc-info.hide {
    margin: 0 auto;
    gap: 4px;
  }
  .cbi-doc-info.hide:hover .hide-info {
    visibility: visible;
  }
  .cbi-doc-info.menu-open .info-btn {
    display: flex;
  }
`;
